module.exports = "/static/img/japan.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/japan.jpg
// module id = 463
// module chunks = 0